import { Checkbox } from "@blueprintjs/core";
import { FGCustomPanel, FieldGroup, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { Link } from "react-router-dom";

import { ColorApi, ColorGridDto } from "../../../../../api";
import { SRSHCustomSelector } from "../../../../../components";
import { ERoutes } from "../../../../../ERoutes";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IColorSelectorProps {
  editMode: boolean;
}

export const ColorSelector: React.FunctionComponent<IColorSelectorProps> = ({ editMode }) => {
  const { t } = useTl();
  const colorApi = useApiService(ColorApi);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        headerAlignment: "center",
        alignment: "center",
        render: (row: ColorGridDto) => (
          <Link target="_blank" to={`${ERoutes.color}/${row.colorId}/detail/view`}>
            {row.name}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Code),
        fieldName: "code",
      },
      {
        header: () => t(ETLCodes.OfficialColor),
        fieldName: "official",
        render: (row: ColorGridDto) => <Checkbox checked={row.official} disabled />,
      },
    ],
    [t]
  );

  const searchColorFunc = React.useCallback(
    async (sObj) => {
      return await colorApi.baseSearch(sObj);
    },
    [colorApi]
  );
  const searchColorIdsFunc = React.useCallback(
    async (sObj) => {
      return await colorApi.searchIds(sObj);
    },
    [colorApi]
  );

  return (
    <FieldGroup columns={1}>
      <FGCustomPanel>
        {(ctx) => (
          <SRSHCustomSelector
            linkedIds={ctx.formik.values?.colorIds}
            columns={columns}
            onLinkedIdsChanged={(ids) => ctx.formik.setFieldValue("colorIds", ids)}
            idField="colorId"
            searchFunction={searchColorFunc}
            searchIdsFunc={searchColorIdsFunc}
            editMode={editMode}
          />
        )}
      </FGCustomPanel>
    </FieldGroup>
  );
};
